<template>
  <section class="content">

    <!--save button-->
    <div class="row">
      <button type="button" class="btn btn-info btn-robot-setting-save pull-right" v-on:click="modifySetting">Save</button>
    </div>
    <!--save button-->


    <!--content-->
    <div class="row">
      <div class="robot-setting-content">
        <p><i class="fa fa-play"></i>&nbsp;&nbsp;&nbsp;Notification of&nbsp;&nbsp;<strong class="security-state-dialog-status">TASK START</strong></p>
        <textarea class="form-control robot-setting-input" v-model="taskStartSetting" placeholder="Task starts..."></textarea>
      </div>
      <div class="robot-setting-content">
        <p><i class="fa fa-pause"></i>&nbsp;&nbsp;&nbsp;Notification of&nbsp;&nbsp;<strong class="security-state-dialog-status">TASK COMPLETION</strong></p>
        <textarea class="form-control robot-setting-input" v-model="taskEndSetting" placeholder="Task completed..."></textarea>
      </div>
    </div>
    <!--content-->

  </section>
</template>
<script>
import api from '../../api'
import utils from '../../utils'
import global from '../Global.vue'
import config from '../../config'

export default {
  name: 'GeneralSetting',
  data () {
    return {
      taskStartSetting: '',
      taskEndSetting: ''
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
  },
  methods: {
    init () {
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/generalsetting?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            var setting = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
            if (setting) {
              this.taskStartSetting = setting.taskstart
              this.taskEndSetting = setting.taskend
            }
          }
        })
    },
    modifySetting () {
      this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
      var params = new URLSearchParams()
      var jsons = {
        appid: this.$route.query.appid,
        taskstart: this.taskStartSetting,
        taskend: this.taskEndSetting
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/modifygeneralsetting?_type=json', params)
        .then(response => {
          this.$store.commit('TOGGLE_FULLSCREEN_LOADING')
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
          }
        })
    }
  },
  filters: {
  }
}

</script>


<style>
</style>



// WEBPACK FOOTER //
// GeneralSetting.vue?7a20d240